import React, { useEffect, useState } from "react";
import DashboardHeader from "../../components/auth/DashboardHeader";
import Sidebar from "../../components/auth/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import moment from "moment";
import { Loader } from "../../components/Loader";
import { errorSwal } from "../../helper/helper";
import API from "../../helper/AxiosInterceptor";
import copy from "copy-to-clipboard";
import { FaSun, FaMoon } from "react-icons/fa";

const Apps = () => {
  //save app
  const [existAppNameMsg, setAppNameMsg] = useState("");
  const [appName, setAppName] = useState("");
  const [description, setDescription] = useState("");
  const [logo, setLogo] = useState(null); // New state for logo
  const [theme, setTheme] = useState("WHITE"); // New state for theme
  const [toleranceMargin, setToleranceMargin] = useState(0); // New state for toleranceMargin
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  //show app list
  const [apps, setApps] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  //show public and private key
  const [publicKey, setPublicKey] = useState("");
  const [privateKey, setPrivateKey] = useState("");
  //updating name and description
  const [editAppId, setEditAppId] = useState("");
  const [editAppName, setEditAppName] = useState("");
  const [editDescription, setEditDescription] = useState("");
  const [editLogo, setEditLogo] = useState(null); // New state for editing logo
  const [editLogoPreview, setEditLogoPreview] = useState(""); // Preview for existing or new logo
  const [editTheme, setEditTheme] = useState("WHITE"); // State for editing theme
  const [editToleranceMargin, setEditToleranceMargin] = useState(0); // State for editing toleranceMargin
  const [removeLogo, setRemoveLogo] = useState(false); // State for removing logo
  const navigate = useNavigate();



  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 1000);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  const fetchApps = async () => {
    try {
      setIsLoading(true);
      const response = await API.get(
        `${process.env.REACT_APP_API_URL}/apps/get`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          params: {
            pageNo: currentPage,
            limitVal: 10,
            search: searchQuery,
          },
        }
      )
        .then((resp) => {
          console.log("res", resp);
          setApps(resp?.data?.data);
          setCurrentPage(resp?.data?.currentPage);
          setTotalPages(resp?.data?.totalPages);
        })
        .catch((error) => {
          console.error("error in apss list", error);
        });
    } catch (error) {
      console.error("Error fetching apps:", error);
    } finally {
      setIsLoading(false);
      await rahul();
    }
  };

  // useEffect(() => {
  //   fetchApps(currentPage);
  // }, [currentPage, searchQuery]);

  useEffect(() => {
    fetchApps(currentPage);
  }, [currentPage, debouncedSearch]);


  // Handle logo file selection
  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type
      const validTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!validTypes.includes(file.type)) {
        toast.error("Only PNG and JPG files are allowed");
        setLogo(null);
        return;
      }

      // Validate file size (5MB)
      const maxSize = 5 * 1024 * 1024; // 5MB in bytes
      if (file.size > maxSize) {
        toast.error("File size must be less than 5MB");
        setLogo(null);
        return;
      }

      setLogo(file);
    }
  };

  // Handle edit logo file selection
  const handleEditLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type
      const validTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!validTypes.includes(file.type)) {
        toast.error("Only PNG and JPG files are allowed");
        setEditLogo(null);
        return;
      }

      // Validate file size (5MB)
      const maxSize = 5 * 1024 * 1024; // 5MB in bytes
      if (file.size > maxSize) {
        toast.error("File size must be less than 5MB");
        setEditLogo(null);
        return;
      }

      setEditLogo(file);
      setEditLogoPreview(URL.createObjectURL(file)); // Show preview of new file
    }
  };

  const handlePreview = async () => {
    const dummyData = {
      logo: null, // Will optionally be updated with base64
      theme: theme,
      amount: "100.00",
      symbol: "USDT",
      recivedAmount: "50.00",
      status: "PENDING FROM BUYER SIDE",
      timeLeft: "23h 59m 59s",
      expireTime: Math.floor(Date.now() / 1000) + 86400,
      createdAt: new Date().toISOString(),
      toAddress: "T9yD14Nj9j7xAB4dbGeiX9h8unkkhxnXV",
      chainId: 1, // Ethereum Mainnet (example)
      buyerEmail: "buyer@example.com",
      code: "USDT",
      transactionType: "Deposit",
      fiatCurrency: "USD",
      coinId: "tether",
      cryptoAmount: "100",
      pricePerCoin: "1.00",
    };

    if (logo) {
      const reader = new FileReader();
      reader.onloadend = () => {
        dummyData.logo = reader.result; // Base64 string
        localStorage.setItem("preview_payment_data", JSON.stringify(dummyData));
        window.open("/payment-information/preview", "_blank");
      };
      reader.readAsDataURL(logo);
    } else {
      localStorage.setItem("preview_payment_data", JSON.stringify(dummyData));
      window.open("/payment-information/preview", "_blank");
    }
  };

  const handleEditPreview = async () => {
    const dummyData = {
      logo: editLogoPreview, // Use existing preview URL (might be relative or absolute)
      theme: editTheme,
      amount: "100.00",
      symbol: "USDT",
      recivedAmount: "50.00",
      status: "PENDING FROM BUYER SIDE",
      timeLeft: "23h 59m 59s",
      expireTime: Math.floor(Date.now() / 1000) + 86400,
      createdAt: new Date().toISOString(),
      toAddress: "T9yD14Nj9j7xAB4dbGeiX9h8unkkhxnXV",
      chainId: 1, // Ethereum Mainnet (example)
      buyerEmail: "buyer@example.com",
      code: "USDT",
      transactionType: "Deposit",
      fiatCurrency: "USD",
      coinId: "tether",
      cryptoAmount: "100",
      pricePerCoin: "1.00",
    };

    // If a new file is selected, convert to base64
    if (editLogo) {
      const reader = new FileReader();
      reader.onloadend = () => {
        dummyData.logo = reader.result; // Base64 string
        localStorage.setItem("preview_payment_data", JSON.stringify(dummyData));
        window.open("/payment-information/preview", "_blank");
      };
      reader.readAsDataURL(editLogo);
    } else {
      // Use existing preview (ensure it's absolute or handled in PaymentInformation)
      // editLogoPreview is already set to absolute URL or empty in fetchAppDetails
      localStorage.setItem("preview_payment_data", JSON.stringify(dummyData));
      window.open("/payment-information/preview", "_blank");
    }
  };



  async function rahul() {
    // Select the element with the class "modal-backdrop fade show"
    const backdrop = document.querySelector(".modal-backdrop.fade.show");
    if (backdrop) {
      backdrop.remove(); // Remove the element from the DOM
    }
  }

  //save app
  const handleCreateApp = async () => {
    setIsLoading(true);
    const newErrors = {};
    await rahul();

    // Validate form inputs
    if (!appName.trim()) {
      newErrors.appName = "App Name is required";
      toast.error("Please enter App Name");
    }


    if (!description.trim()) {
      newErrors.description = "Description is required";
      toast.error("Please enter Description");
    }

    if (toleranceMargin < 0 || toleranceMargin > 100) {
      newErrors.toleranceMargin = "Margin must be between 0 and 100";
      toast.error("Tolerance margin must be between 0% and 100%");
    }

    // If there are validation errors, set them and return
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setIsLoading(false);
      return;
    }

    // Clear previous errors and messages
    setErrors({});
    setAppNameMsg("");

    try {
      const formData = new FormData();
      formData.append("name", appName);
      formData.append("description", description);
      formData.append("theme", theme);
      formData.append("toleranceMargin", toleranceMargin);
      if (logo) {
        formData.append("logo", logo);
      }

      // Make the API request
      const response = await API.post(
        `${process.env.REACT_APP_API_URL}/apps/add`,
        formData, // Send formData instead of JSON
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data", // Set header for file upload
          },
        }
      );
      // toast.success("App created successfully!");

      // Handle the response based on the status code
      if (response?.status === 201) {
        toast.success("App created successfully!");
        setAppName("");
        setDescription("");
        setLogo(null); // Reset logo state
        setTheme("WHITE"); // Reset theme
        setToleranceMargin(0); // Reset toleranceMargin
        setAppNameMsg("");
        setIsLoading(false);

        // Trigger close button click to hide modal
        document.getElementById("exampleModal")?.querySelector(".btn-close")?.click();

        // Fetch the updated list of apps
        fetchApps(1);
        // window.location.reload();
      }
    } catch (error) {
      console.error("Error creating app:", error);

      // Handle error responses
      if (error?.response) {
        if (error?.response?.status === 400) {
          errorSwal(
            "Insufficient TRX!",
            "Please contact the administrator for App Activation"
          );
        } else {
          setAppNameMsg(
            error.response.data.message ||
            "An error occurred while creating the app."
          );
        }
      } else {
        setAppNameMsg("An error occurred while creating the app.");
      }

      setIsLoading(false);
    } finally {
      setIsLoading(false);
      await rahul();
    }
  };

  // const handlePageChange = (pageNo) => {
  //   if (pageNo > 0 && pageNo <= totalPages) {
  //     setCurrentPage(pageNo);
  //   }
  // };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  //showing public and private keys
  const fetchApiKeys = async (appId) => {
    try {
      const response = await API.get(
        `${process.env.REACT_APP_API_URL}/apps/keys`,

        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          params: {
            appId: appId,
          },
        }
      );

      if (response?.data) {
        setPublicKey(response?.data?.publicKey);
        setPrivateKey(response?.data?.privateKey);
      }
    } catch (error) {
      console.error("Error fetching API keys:", error);
    }
  };

  const handleApiKeyClick = (appId) => {
    fetchApiKeys(appId);
  };

  //copy public private keys
  const handleCopyClick = (text) => {
    copy(text);
    toast.success("Copied to clipboard!");
    // navigator.clipboard
    //   .writeText(text)
    //   .then(() => {
    //     toast.success("Copied to clipboard!");
    //   })
    //   .catch((err) => {
    //     console.error("Failed to copy: ", err);
    //   });
  };

  //fetch app details for editing
  const fetchAppDetails = async (appId) => {
    try {
      const response = await API.get(
        `${process.env.REACT_APP_API_URL}/apps/getById`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          params: {
            appId: appId,
          },
        }
      );

      if (response?.data) {
        setEditAppId(appId);
        setEditAppName(response?.data?.data?.name);
        setEditDescription(response?.data?.data?.description);
        // Prepend API URL if the logo path is relative
        if (response?.data?.data?.logo) {
          setEditLogoPreview(`${process.env.REACT_APP_API_URL}/${response?.data?.data?.logo}`);
        } else {
          setEditLogoPreview("");
        }
        setEditLogo(null); // Reset new logo selection
        setRemoveLogo(false); // Reset remove logo flag
        setEditTheme(response?.data?.data?.theme || "WHITE"); // Set existing theme
        setEditToleranceMargin(response?.data?.data?.toleranceMargin || 0);
      }
    } catch (error) {
      console.error("Error fetching app details:", error);
    }
  };

  const handleEditAppClick = (appId) => {
    fetchAppDetails(appId);
  };

  //update app
  const handleUpdateApp = async () => {
    const newErrors = {};
    if (!editAppName.trim()) newErrors.appName = "App Name is required";
    if (!editDescription.trim()) {
      newErrors.description = "Description is required";
      toast.error("Please enter Description");
    }

    if (editToleranceMargin < 0 || editToleranceMargin > 100) {
      newErrors.toleranceMargin = "Margin must be between 0 and 100";
      toast.error("Tolerance margin must be between 0% and 100%");
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    setAppNameMsg("");

    try {
      const formData = new FormData();
      formData.append("name", editAppName);
      formData.append("description", editDescription);
      formData.append("theme", editTheme);
      formData.append("toleranceMargin", editToleranceMargin);
      if (editLogo) {
        formData.append("logo", editLogo);
      }
      if (removeLogo) {
        formData.append("removeLogo", "true");
      }

      const response = await API.put(
        `${process.env.REACT_APP_API_URL}/apps/update`,
        formData, // Send formData
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data", // Set header
          },
          params: {
            appId: editAppId,
          },
        }
      )
        .then((resp) => {
          console.log("App updated successfully:", resp?.data);
          toast.success("App updated successfully!");

          // Trigger close button click to hide modal
          document.getElementById("exampleModal1")?.querySelector(".btn-close")?.click();

          fetchApps(1); // Fetch the first page of apps
        })
        .catch((error) => {
          setAppNameMsg("This app name already exists");
          console.error("Error updating app111:", error);
        });
    } catch (error) {
      console.error("Error updating app222:", error);
    }
  };

  console.log("isloading...", isLoading);

  return (
    <>
      <DashboardHeader />
      <div className="site-bg">
        <div className="dashborad-content-bg">
          <aside className="sidebar">
            <Sidebar />
          </aside>
          <div className="dashborad-warper" style={{ position: "relative" }}>
            {isLoading && <Loader inline={true} />}
            <div className="transactions-list">
              <div className="dashborad-head">
                <div className="dashborad-search-box">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search here App Name"
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />
                </div>
                <div className="view-balances-btn">
                  {apps.length === 3 ? (
                    <a
                      // href=""
                      className="btn"
                      onClick={() => {
                        if (apps.length === 3) {
                          errorSwal(
                            "Apps Limit exceeded",
                            "Maximum apps can be 3."
                          );
                        }
                      }} // Open modal using state
                    >
                      Create New App
                    </a>
                  ) : (
                    <a
                      // href=""
                      className="btn"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                    >
                      Create New App
                    </a>
                  )}
                </div>
              </div>
              <div className="white-bg my-apps-content padd20">
                <div className="table-box">
                  <table className="table">
                    <tbody>
                      <tr>
                        <th>App Id</th>
                        <th>App Name</th>
                        <th>Created On</th>
                        <th>Action</th>
                      </tr>

                      {apps?.length > 0 ? (
                        apps.map((app) => (
                          <tr key={app?._id}>
                            <td>
                              <Link to={`/apps-detail/${app?._id}`}>
                                {app?._id}
                              </Link>
                              <button
                                onClick={() => handleCopyClick(app?._id)}
                                style={{
                                  border: "none",
                                  background: "transparent",
                                  cursor: "pointer",
                                  padding: 0,
                                }}
                              >
                                <i
                                  className="ti ti-copy"
                                  style={{ fontSize: "16px" }}
                                ></i>
                              </button>
                            </td>

                            <td>
                              <Link to={`/apps-detail/${app?._id}`}>
                                {app?.name}
                              </Link>
                            </td>

                            <td>
                              <Link to={`/apps-detail/${app?._id}`}>
                                {moment(app?.createdAt).format("DD MMMM YYYY")}
                              </Link>
                            </td>
                            <td>
                              <div className="table-action-btn api-key-btn">
                                <a
                                  href=""
                                  data-bs-toggle="modal"
                                  data-bs-target="#exampleModal2"
                                  onClick={() => handleApiKeyClick(app?._id)}
                                >
                                  <i className="ti ti-key" />
                                  <span>API Key</span>
                                </a>
                                <a
                                  href=""
                                  data-bs-toggle="modal"
                                  data-bs-target="#exampleModal1"
                                  onClick={() => handleEditAppClick(app?._id)}
                                >
                                  <i className="ti ti-edit" />
                                  <span>Edit App</span>
                                </a>
                                <Link to={`/apps-detail/${app?._id}`}>
                                  <i className="ti ti-eye" />
                                  <span>View App</span>
                                </Link>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%",
                                marginTop: "20px",
                              }}
                            >
                              <p>Data not found</p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {/* <div className="pagination-box">
                  <ul>
                    <li>
                      <a
                        href="#"
                        // onClick={() => handlePageChange(currentPage - 1)}
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(currentPage - 1);
                        }}
                        disabled={currentPage === 1}
                      >
                        <img src="images/left-arrow.png" alt="arrow" />
                      </a>
                    </li>
                    {[...Array(totalPages).keys()].map((pageNo) => (
                      <li
                        key={pageNo + 1}
                        className={currentPage === pageNo + 1 ? "active" : ""}
                      >
                        <a
                          href="#"
                          // onClick={() => handlePageChange(pageNo + 1)}
                          onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(pageNo + 1);
                          }}
                        >
                          {pageNo + 1}
                        </a>
                      </li>
                    ))}
                    <li>
                      <a
                        href="#"
                        // onClick={() => handlePageChange(currentPage + 1)}
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(currentPage + 1);
                        }}
                        disabled={currentPage === totalPages}
                      >
                        <img src="images/right-arrow.png" alt="arrow" />
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div >

      {/* Create New App */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Create new App
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setErrors({});
                  setAppNameMsg("");
                  setAppName("");
                  setDescription("");
                  setTheme("WHITE");
                }}
              />
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>Enter Name</label>
                <div className="form-group-inner">
                  <div className="fild-icon">
                    <i className="ti ti-keyframe" />
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Name"
                    value={appName}
                    onChange={(e) => setAppName(e.target.value)}
                  />
                  {errors.appName && (
                    <div className="error">{errors.appName}</div>
                  )}
                  <span className="error">{existAppNameMsg}</span>
                </div>
              </div>
              <div className="form-group">
                <label>Description</label>
                <div className="form-group-inner">
                  <div className="fild-icon">
                    <i className="ti ti-info-circle" />
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                  {errors.description && (
                    <div className="error">{errors.description}</div>
                  )}
                </div>
              </div>
              <div className="form-group">
                <label>Payment Page Theme</label>
                <div className="theme-toggle-container">
                  <input
                    type="checkbox"
                    className="checkbox"
                    id="checkbox-create"
                    checked={theme === "WHITE"}
                    onChange={() => setTheme(theme === "WHITE" ? "DARK" : "WHITE")}
                  />
                  <label htmlFor="checkbox-create" className="label">
                    <FaSun className="icon-sun" />
                    <FaMoon className="icon-moon" />
                    <div className="ball" />
                  </label>
                </div>
              </div>
              <div className="form-group">
                <label>Deposit Tolerance Margin (%)</label>
                <p className="text-muted" style={{ fontSize: "12px", marginBottom: "8px" }}>
                  Payments below the requested amount by this percentage will be accepted (e.g. 1% to account for network fees).
                </p>
                <div className="form-group-inner">
                  <div className="fild-icon">
                    <i className="ti ti-percentage" />
                  </div>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="e.g. 1"
                    min="0"
                    max="100"
                    step="0.01"
                    value={toleranceMargin}
                    onChange={(e) => setToleranceMargin(e.target.value)}
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Upload Logo (Can accept .jpg, .png)</label>
                <div className="form-group-inner">
                  <div className="fild-icon">
                    <i className="ti ti-upload" />
                  </div>
                  <input
                    type="file"
                    className="form-control"
                    accept=".jpg,.jpeg,.png"
                    onChange={handleLogoChange}
                  />
                  {logo && <div className="mt-2 text-success">Selected: {logo.name}</div>}
                  <small className="text-muted d-block mt-1">Max size 5MB</small>
                </div>
              </div>
              <div className="form-submit-btn d-flex gap-2">
                <button className="btn btn-secondary" onClick={handlePreview} style={{ marginRight: "10px", backgroundColor: "#6c757d", borderColor: "#6c757d" }}>
                  Preview
                </button>
                <button className="btn" onClick={handleCreateApp}>
                  Create App
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Edit App */}
      <div
        className={`modal fade ${isLoading ? "d-none" : ""}`}
        id="exampleModal1"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel1">
                Edit App
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setErrors({});
                  setAppNameMsg("");
                }}
              />
            </div>
            <div className="modal-body">
              <form>
                <div className="form-group">
                  <label>Enter Name</label>
                  <div className="form-group-inner">
                    <div className="fild-icon">
                      <i className="ti ti-keyframe" />
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Name"
                      value={editAppName}
                      onChange={(e) => setEditAppName(e.target.value)}
                    />
                    {errors.appName && (
                      <p className="error">{errors.appName}</p>
                    )}
                    {existAppNameMsg && (
                      <p className="error">{existAppNameMsg}</p>
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <label>Description</label>
                  <div className="form-group-inner">
                    <div className="fild-icon">
                      <i className="ti ti-info-circle" />
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Description"
                      value={editDescription}
                      onChange={(e) => setEditDescription(e.target.value)}
                    />
                    {errors.description && (
                      <p className="error">{errors.description}</p>
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <label>Payment Page Theme</label>
                  <div className="theme-toggle-container">
                    <input
                      type="checkbox"
                      className="checkbox"
                      id="checkbox-edit"
                      checked={editTheme === "WHITE"}
                      onChange={() => setEditTheme(editTheme === "WHITE" ? "DARK" : "WHITE")}
                    />
                    <label htmlFor="checkbox-edit" className="label">
                      <FaSun className="icon-sun" />
                      <FaMoon className="icon-moon" />
                      <div className="ball" />
                    </label>
                  </div>
                </div>

                <div className="form-group">
                  <label>Deposit Tolerance Margin (%)</label>
                  <p className="text-muted" style={{ fontSize: "12px", marginBottom: "8px" }}>
                    Payments below the requested amount by this percentage will be accepted (e.g. 1% to account for network fees).
                  </p>
                  <div className="form-group-inner">
                    <div className="fild-icon">
                      <i className="ti ti-percentage" />
                    </div>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="e.g. 1"
                      min="0"
                      max="100"
                      step="0.01"
                      value={editToleranceMargin}
                      onChange={(e) => setEditToleranceMargin(e.target.value)}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Logo</label>
                  {editLogoPreview && !removeLogo && (
                    <div className="mb-2" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <img
                        src={editLogoPreview}
                        alt="Current Logo"
                        style={{ maxWidth: "100px", maxHeight: "100px", objectFit: "contain" }}
                      />
                      <button
                        type="button"
                        className=""
                        style={{
                          padding: "4px 8px",
                          fontSize: "14px"
                        }}
                        onClick={() => {
                          setRemoveLogo(true);
                          setEditLogoPreview("");
                          setEditLogo(null);
                        }}
                      >
                        <i className="ti ti-trash" style={{ fontSize: "14px" }} />

                      </button>
                    </div>
                  )}
                  {removeLogo && (
                    <div className="mb-2" style={{ color: "#6c757d", fontStyle: "italic" }}>
                      <span>Logo will be removed. Platform default will be used.</span>
                      <button
                        type="button"
                        style={{
                          marginLeft: "10px",
                          backgroundColor: "transparent",
                          color: "#F5A623",
                          border: "none",
                          cursor: "pointer",
                          textDecoration: "underline"
                        }}
                        onClick={() => {
                          setRemoveLogo(false);
                          // Refetch the original logo
                          fetchAppDetails(editAppId);
                        }}
                      >
                        Undo
                      </button>
                    </div>
                  )}
                  <div className="form-group-inner">
                    <div className="fild-icon">
                      <i className="ti ti-upload" />
                    </div>
                    <input
                      type="file"
                      className="form-control"
                      accept=".jpg,.jpeg,.png"
                      onChange={handleEditLogoChange}
                    />
                    {editLogo && <div className="mt-2 text-success">Selected: {editLogo.name}</div>}
                    <small className="text-muted d-block mt-1">Max size 5MB</small>
                  </div>
                </div>
              </form>
              <div className="form-submit-btn d-flex gap-2">
                <button className="btn btn-secondary" onClick={(e) => { e.preventDefault(); handleEditPreview(); }} style={{ marginRight: "10px", backgroundColor: "#6c757d", borderColor: "#6c757d" }}>
                  Preview
                </button>
                <button className="btn" onClick={handleUpdateApp}>
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* API Key */}
      <div
        className="modal fade"
        id="exampleModal2"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel2"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel1">
                API Key
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body api-key-modal">
              <div className="form-group app-id-box">
                <label>Api Key</label>
                <div className="form-group-inner">
                  <input
                    type="text"
                    className="form-control"
                    value={`${publicKey.slice(0, 8)}*****************`}
                    readOnly
                  />
                  <button
                    className="copy-code-btn"
                    onClick={() => handleCopyClick(publicKey)}
                  >
                    <i className="ti ti-copy" />
                  </button>
                </div>
              </div>
              <div className="form-group app-id-box">
                <label>Secret Key</label>
                <div className="form-group-inner">
                  <input
                    type="text"
                    className="form-control"
                    value={`${privateKey.slice(0, 8)}*****************`}
                    readOnly
                  />
                  <button
                    className="copy-code-btn"
                    onClick={() => handleCopyClick(privateKey)}
                  >
                    <i className="ti ti-copy" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default Apps;
